import { render, staticRenderFns } from "./ReportOrdersEvaluation.vue?vue&type=template&id=34a71cdc"
import script from "./ReportOrdersEvaluation.vue?vue&type=script&lang=ts"
export * from "./ReportOrdersEvaluation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports